export default {
  'form.required': 'الزامی',
  'input.good': 'خوب',

  'header.book': 'پرواز',
  'header.upgradetobusiness': 'همکار ما شوید',
  'header.checkin': 'رزرو',
  'header.manage': 'داشبورد',
  'header.login': 'ورود',
  'header.signup': 'ثبت نام',
  'header.dashboard': 'داشبورد',
  'header.logout': 'خروج',
  'header.ticket': 'درخواست',
  'header.Booking': 'رزرو',
  'header.smarttripsi': 'تریپسی دانا',
  'header.smarttripord': 'تریپ اُرد دانا',
  'header.aboutus': 'درباره ما',
  'header.contactus': 'ارتباط با ما',
  //dashbord
  'dashboard.flightDescriptionTripsi':
    'پروازهای داخلی و خارجی را از تریپسی با بهترین نرخ خریداری کنید',
  'dashboard.flightDescriptionTripord':
    'پروازهای داخلی و خارجی را از تریپ اُرد با بهترین نرخ خریداری کنید',
  'dashboard.overview': 'بررسی اجمالی',
  'dashboard.book': 'رزرو',
  'dashboard.search': 'جستجو',
  'dashboard.reserve': 'صادر شده',
  'dashboard.staffs': 'کارمندان',
  'dashboard.random': 'تصادفی',
  'dashboard.stats': 'آمار',
  'dashboard.overalview': 'دید کلی',
  'dashboard.lastactivities': 'آخرین فعالیت ها',
  'dashboard.opportunities': 'فرصت ها',
  'dashboard.tickets': 'خریداری شده',
  'dashboard.open': 'اخبار',
  'dashboard.rating': 'رتبه',
  'dashboard.openrequest': 'درخواست ها',
  'dashboard.derik': 'امتیاز دریک',
  'dashboard.showmore': 'نمایش بیشتر',
  'dashboard.onlinetickets': 'آنلاین تیکت',
  'dashboard.favoritetrips': 'مقاصد مورد علاقه من',
  //footer
  'footer.supports': 'پشتیبانی',
  'footer.onlinechat': 'آنلاین چت',
  'footer.customer': 'ارتباط با مشتری',
  'footer.claim': 'ثبت شکایات',
  'footer.reserve': 'رزرو',
  'footer.fax': 'نمابر',
  'footer.email': 'ایمیل: Support.Tripsi.com',
  'footer.services': 'خدمات ما',
  'footer.flight': 'پرواز',
  'footer.hotel': 'هتل',
  'footer.tour': 'تور',
  'footer.who': 'ما که هستیم',
  'footer.aboutus': 'درباره ما',
  'footer.contactus': 'ارتباط با ما',
  'footer.members': 'اعضا تیم',
  'footer.board': 'هیئت مدیره',
  'footer.history': 'تاریخچه',
  'footer.privacypolicy': 'حریم خصوصی و سیاست ها',
  'footer.privacy': 'حریم خصوصی',
  'footer.address': 'آدرس',
  'footer.rules': 'قوانین',
  'footer.subscribe': 'عضویت در خبرنامه',
  'footer.copyright': 'کلیه حقوق این سایت متعلق به تریپسی می باشد.',
  'footer.rules': 'قوانین',
  'footer.tourismMagazine': 'مجله گردشگری',
  'footer.customerClub': 'باشگاه مشتریان',
  'footer.ticketGuide': 'راهنمای بلیت',
  'aboutus.tripsi': 'درباره تریپسی',
  'aboutus.tripord': 'درباره تریپ اُرد',
  'aboutus.address':
    'تهران خیابان ولیعصر، بالاتر از زعفرانیه، جنب بانک رفاه، پلاک 3061، طبقه دوم واحد 6 ',
  'aboutus.iranphone': '021-22749095',
  'aboutus.canadaaddress': 'آدرس : 719-938 HOWS STREET, VANCOUVER',
  'aboutus.canadaphone': '001-7786828070',
  'aboutus.company': 'شرکت تریپسی',
  'aboutus.tripsiAboutus':
    ' شرکت خدمات مسافرت هوائی جهانگردی و زیارتی طلوع در سال ۱۳۷۳ فعالیت خود را در عرصه صنعت بزرگ گردشگری آغاز نمود. تیم بزرگ طلوع با بیش از 25 کارمند که شامل فروش در تهران می شود و بخش فنی در شیراز همیشه در جستجو هستند تا بهترین خدمات و با کیفیت ترین نرم افزار را جهت رضایت حال ارائه دهندگان ارائه دهند. این شرکت از سال 1401 فعالیت خود را در عرصه خدمات توریستی به صورت آنلاین با نام تریپسی آغاز کرد. خط مشی سامانه تریپسی براصل رضایت مشتری و ذینفعان و ارائه خدمات برتر و متمایز به مشتریان بنا شده است.',
  'aboutus.tripordAboutus':
    'در تریپ اُرد، ما بیش از یک سامانه آنلاین سفر هستیم؛ ما همراهی مطمئن برای تبدیل رویاهای سفر به واقعیت‌هایی فراموش‌نشدنی هستیم. تریپ اُرد در سال ۲۰۲۱ با بیش از دو دهه تجربه در صنعت گردشگری متولد شد، با این چشم‌انداز که یک اکوسیستم جامع، نوآورانه و بی‌نقص برای سفر خلق کند.',
  'aboutus.service1_tripsi': 'نمایندگی کلیه ایرلاین های داخلی و بین المللی',
  'aboutus.service2_tripsi': 'نمایندگی فروش بلیطهای بین شهری خارج از کشور ',
  'aboutus.service3_tripsi':
    'نمایندگی فروش بلیطهای خارجی به صورت سیستمی و چارتری',
  'aboutus.service4_tripsi':
    'نمایندگی فروش بلیطهای داخلی به صورت سیستمی و چارتری',
  'aboutus.service5_tripsi': 'نمایندگی فروش بلیط قطارهای بین المللی',
  'aboutus.service6_tripsi': 'صدور بلیط های شروع از خارج از کشور (SOTO)',
  'aboutus.service7_tripsi': 'برگزاری و تهیه تورهای داخلی و خارجی',
  'aboutus.service8_tripsi': 'برگزاری سمینارها و همایش های تخصصی',
  'aboutus.service9_tripsi':
    'سرویس دهی در امور ویزا و خدمات سفارت اعم از (وقت سفارت و پیکاپ پاسپورت)',
  'aboutus.service10_tripsi': 'ارائه خدمات ترانسفر تشریفات فرودگاهی ( CIP )',
  'aboutus.service11_tripsi': 'رزرو هتل در سراسر ایران و جهان ',
  'aboutus.service12_tripsi':
    'برگزاری کاروان های زیارتی، عتبات و عمره زیرنظر حج و زیارت',
  'aboutus.service1_tripord':
    'درباره تریپ اُرد: بازتعریف سفر، یک سفر در یک زمان. در تریپ اُرد ما معتقدیم سفر باید بی‌دردسر، شخصی‌سازی شده و به‌یادماندنی باشد. ماموریت ما این است که نحوه کشف جهان توسط شما را با ارائه راه‌حل‌های هوشمند، تجربیات انتخاب شده و پشتیبانی 24/7 - همه در یک پلتفرم - متحول کنیم. از اقامت‌های لوکس و اکوتوریسم تا جواهرات پنهان و اقامت‌گاه‌های مزرعه، ما شما را به ماجراجویی‌های فوق‌العاده با قیمت‌های رقابتی متصل می‌کنیم.',
  'aboutus.service2_tripord': 'چرا با ما سفر کنید؟',
  'aboutus.service3_tripord':
    '• پلتفرم همه‌کاره: پروازها، اقامت‌ها، تورها و بیشتر، متناسب با نیازهای شما.',
  'aboutus.service4_tripord':
    '• نوآوری و اعتماد: فناوری پیشرفته، رزروهای امن و قیمت‌گذاری شفاف.',
  'aboutus.service5_tripord':
    '• پاداش‌های معنادار: از طریق باشگاه وفاداری تریپ اُرد امتیاز کسب کرده و استفاده کنید.',
  'aboutus.service6_tripord':
    '• پشتیبانی اختصاصی: کمک در هر زمان، هر مکان، 365 روز سال.',
  'aboutus.service7_tripord':
    '• سفر پایدار: ما از گردشگری دوستدار محیط زیست و تاثیر اجتماعی حمایت می‌کنیم.',
  'aboutus.service8_tripord':
    'با پشتوانه تخصص و اشتیاق برای کشف، تریپ اُرد فقط یک سرویس سفر نیست - بلکه شریک قابل اعتماد شما در خلق سفرهایی الهام‌بخش است.',
  'aboutus.service9_tripord': 'بیشتر کاوش کنید. کمتر نگران باشید.',
  'dumb.amount_of_new_users': 'Amount of new users: {amountOfUsers}',
  'dumb.display_width': '<strong>Width: {width}</strong>',
  'dumb.display_height': '<strong>Height: {height}</strong>',

  'footer.english': 'انگلیسی',
  'footer.persian': 'فارسی',
  /**Added by P.daneshmand */
  'confirmation.reject': 'خیر',
  'confirmation.confirm': 'بلی',
  'confirmation.confirmTitle': 'فرم تایید',
};
